// =============================================================================
// O orçamento do ano seguinte montado pelas áreas (migration 071) — as regras
// da tela, as mesmas do banco
//
// O banco é quem recusa (rpc_enviar_proposta); aqui a tela avisa antes, para o
// gestor não descobrir no clique de enviar. Em centavos e BigInt.
// =============================================================================

export const MESES = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

export type SituacaoLinha = "rascunho" | "enviada" | "aprovada" | "ajustada" | "devolvida";
export type StatusArea = "nao_iniciada" | "rascunho" | "em_analise" | "devolvida" | "aprovada" | "aprovada_com_ajustes";

export const ROTULO_STATUS_AREA: Record<StatusArea, string> = {
  nao_iniciada: "Não iniciada",
  rascunho: "Em montagem",
  em_analise: "Em análise",
  devolvida: "Devolvida",
  aprovada: "Aprovada",
  aprovada_com_ajustes: "Aprovada com ajustes",
};
export const COR_STATUS_AREA: Record<StatusArea, string> = {
  nao_iniciada: "bg-superficie-2 text-tinta-fraca",
  rascunho: "bg-superficie-2 text-tinta-media",
  em_analise: "bg-atencao-bg text-atencao-tinta",
  devolvida: "bg-risco-bg text-risco-tinta",
  aprovada: "bg-ok-bg text-ok-tinta",
  aprovada_com_ajustes: "bg-ok-bg text-ok-tinta",
};
export const ROTULO_SITUACAO: Record<SituacaoLinha, string> = {
  rascunho: "Rascunho",
  enviada: "Enviada",
  aprovada: "Aprovada",
  ajustada: "Aprovada com ajuste",
  devolvida: "Devolvida",
};

/** A linha que o gestor ainda pode mexer. */
export const editavel = (s: SituacaoLinha): boolean => s === "rascunho" || s === "devolvida";

export const zeros = (): string[] => Array.from({ length: 12 }, () => "0");

export function soma(meses: (string | null | undefined)[]): bigint {
  return meses.reduce<bigint>((s, v) => s + (v ? BigInt(v) : 0n), 0n);
}

/** Os meses (1 a 12) em que o pedido passa a base — a mesma conta de fn_meses_acima. */
export function mesesAcima(base: string[], pedido: string[]): number[] {
  return pedido.flatMap((v, i) => (BigInt(v || "0") > BigInt(base[i] || "0") ? [i + 1] : []));
}

/** Precisa de explicação: algum mês acima do mesmo mês da base, ou o ano acima. */
export function pedeExplicacao(base: string[], pedido: string[]): boolean {
  return mesesAcima(base, pedido).length > 0 || soma(pedido) > soma(base);
}

/** "acima em mar, jun e dez". */
export function textoMesesAcima(meses: number[]): string {
  const nomes = meses.map((m) => MESES[m - 1]!.toLowerCase());
  if (nomes.length <= 1) return nomes.join("");
  return `${nomes.slice(0, -1).join(", ")} e ${nomes.at(-1)}`;
}

/** O valor em todos os meses a partir de um (1 a 12); antes dele, zero. A contratação de abril. */
export function aPartirDe(centavos: string, mesInicio: number): string[] {
  return Array.from({ length: 12 }, (_, i) => (i + 1 >= mesInicio ? centavos : "0"));
}

/** A variação do pedido sobre a base, em %; nula sem base. */
export function variacao(base: bigint, pedido: bigint): number | null {
  return base > 0n ? Number(((pedido - base) * 1000n) / base) / 10 : null;
}
